<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="auto !important"
    class="bg-white pos-relative"
  >
    <v-card>
      <v-card-title class="fs-1-5r bg-grey mb-2">
        SFTP Access Details
      </v-card-title>
      
      <v-card-text class="font-size-16 px-2 pb-2"> Protocol: SFTP </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2"> Host: {{ computedHost }} </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2"> Port: 22 </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2">
        Username: {{ userEmail + ',guests ' + groupName }}
      </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2">
        Password: {{userName}} Yazam MFT password
      </v-card-text>
      <v-divider></v-divider>
      <div class="d-flex justify-space-between pa-4">
        <Button
        :clickAction="sendEmailClicked"
        width="fit-content"
        btnType="blue"
        class="mx-2"
        text="Send Email"
        />
        <Button
          :clickAction="closeDialog"
          width="fit-content"
          btnType="grey"
          text="Cancel"
          class="mx-2"
        />
      </div>
    </v-card>
    <InsertEmailDialogForCasual
      v-if="isShowInsertDialog"
      :closeDialog="() => (isShowInsertDialog = false)"
      :sftpUsername="userEmail + ',guests ' + groupName"
      :isTarget="false"
      :groupName="groupName"
      :groupMembers="groupMembers"
    />
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import InsertEmailDialogForCasual from '@/components/BaseComponents/CasualCommonComponents/InsertEmailDialogForCasual.vue'

export default {
  name: 'SftpDetailsDialogForCasualRecipient',
  data() {
    return {
      dialog: true,
      isShowInsertDialog: false,
    }
  },
  props: {
    groupName: String,
    groupMembers: Array,
    userEmail: String,
    userName: String,
    closeDialog: Function,
  },
  components: { Button, InsertEmailDialogForCasual },

  computed: {
    computedHost() {
      return window.location.host
    },
  },
  methods: {
    sendEmailClicked() {
      this.isShowInsertDialog = true
    },
  },
  mounted() {
console.log(this.groupMembers)
  },
}
</script>

<style scoped>
.select-senders {
  padding: 0px 8px 7px 0px;
  display: flex;
  align-items: center;
}
</style>
